import React, { Ref } from 'react';

import kebabCase from 'lodash/kebabCase';

import { isComponentDisabled, Targets } from '@lumapps/customizations/api';
import { useTranslate } from '@lumapps/translations';

import { BookmarkType } from '../../../types';
import { Bookmark as UI } from './Bookmark';

import './index.scss';

export interface BookmarkProps {
    /** className to be added to the wrapping div */
    className?: string;
    /** Bookmark to display */
    item: BookmarkType;
    /** reference to the bookmark link */
    linkRef?: Ref<HTMLAnchorElement>;
}
/**
 * This component display a links with an icon.
 */
export const Bookmark: React.FC<BookmarkProps> = ({ className = '', item, linkRef }) => {
    const { translateKey } = useTranslate();
    const title = translateKey(item.title);
    const id = kebabCase(item.title);
    const isDisabled = isComponentDisabled(id as Targets);

    if (isDisabled) {
        return null;
    }

    return <UI icon={item.icon} link={item.link} className={className} linkRef={linkRef} title={title} id={id} />;
};
